import * as config from '../../lib/config';
import { toast } from 'react-toastify';
import {
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  CLEAR_PROJECT,
} from './types';
import Auth from '../../auth/auth';

// Actions
const fetchProjectStart = () => ({
  type: FETCH_PROJECT_START,
});

const fetchProjectSuccess = (res) => ({
  type: FETCH_PROJECT_SUCCESS,
  payload: res,
});

const fetchProjectFailure = (error) => ({
  type: FETCH_PROJECT_FAILURE,
  payload: error,
});

export const clearProject = () => ({
  type: CLEAR_PROJECT,
});

export const setProjectSetupHeader = (tabNameAndDescription) => ({
  type: 'SET_PROJECT_SETUP_HEADER',
  payload: tabNameAndDescription,
});

// Error middleware
function handleFetchErrors(res) {
  if (!res.ok) {
    const error = {
      code: res.status,
      message: 'Project could not be found.',
      res: res,
      error: new Error('Project could not be found.'),
    };
    throw error;
  }
  return res;
}

// API Actions
export const fetchProject =
  (tenantId, projectId, updateToast) => (dispatch) => {
    new Auth().checkAuth();
    dispatch(fetchProjectStart());
    return fetch(
      `${config.baseURL()}/api/tenants/${tenantId}/projects/${projectId}`,
      {
        method: 'get',
        credentials: 'include',
      },
    )
      .then(handleFetchErrors)
      .then((res) => res.json())
      .then((json) => {
        dispatch(fetchProjectSuccess(json));
        if (updateToast) {
          toast.update(updateToast.toastId, {
            render: updateToast.message,
            type: toast.TYPE[updateToast.type],
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        dispatch(fetchProjectFailure(error));
      });
  };
